// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_6v2","cls2":"RelatedPapersSidebar-cls2_wzA RelatedPapersSidebar-cls1_6v2"};